import { Component, ViewChild } from '@angular/core';
import { UserListService } from '../services/user-list/user-list.service';
import { FilterSearchBarComponent } from '../reusables/filter-search-bar/filter-search-bar.component';
import { MessageModalComponent } from '../reusable/message-modal/message-modal.component';
import { Sort } from '@angular/material/sort';

@Component({
  selector: 'app-user-hierarchy',
  templateUrl: './user-hierarchy.component.html',
  styleUrls: ['./user-hierarchy.component.css']
})
export class UserHierarchyComponent {
  
  @ViewChild(FilterSearchBarComponent) 
  private SearchBar!:FilterSearchBarComponent;

  @ViewChild(MessageModalComponent) 
  private MessageModal!:MessageModalComponent;

  constructor(
    private userListService : UserListService
  ){}

  userListData:Array<any> = [];
  hierarchyData:Array<any> = [];
  itemsPerPage = 15;
  isTotal:boolean = false;
  current_page:number = 1;
  total_page:number = 1;
  req_parameter:any = {};
  parentHierarchy:Array<any> = [];
  isLoading:boolean = false;
  searchValue:string = "";
  isMobile: boolean = false;
  message:string = "";


  ngOnInit(){
    this.req_parameter.limit = this.itemsPerPage;
    this.getUserList()
  }
  
  async getUserList(isChildQuery:boolean = false) {
    this.message = "";
    this.isLoading = true;
    const res = await this.userListService.getUserByHierarchy(this.req_parameter);
    if (res) {
      if (res.message) {
        this.message = res.message;
      }else{

        if (this.parentHierarchy && res.items.length == 0 && isChildQuery) {
          this.parentHierarchy.pop();
          this.MessageModal.setMessage("This user does not have any children.");
          this.isLoading = false;
          return;
        }
        this.userListData = res.items;
        this.total_page = Math.ceil(res.total / this.itemsPerPage);
        
        if (res.total == 0 && res.items.length == 0) {
          this.message = "No item available."
        }
      }
    }
    this.isLoading = false;
  }

  onSelectTableRow(selectedRow:any){
    this.parentHierarchy.push(selectedRow);
    console.log(this.parentHierarchy);
    this.req_parameter.parent_id = selectedRow.id;
    this.getUserList(true);
  }

  returnToHigerLevel(){
    this.parentHierarchy.pop();
    if (this.parentHierarchy.length > 0) {
      this.req_parameter.parent_id = this.parentHierarchy[this.parentHierarchy.length-1].id;
    }else{
      delete this.req_parameter.parent_id;
    }
    this.getUserList();
  }

  updatePage(selected_page:number){
    this.current_page = selected_page;
    this.req_parameter.offset = selected_page * this.itemsPerPage - this.itemsPerPage;
    this.getUserList();
  }

  clearAllFilters(){
    this.SearchBar.clearSearch();
    this.searchValue = "";
    delete this.req_parameter.search_param;
    this.getUserList();
  }
  
  updateSearchValue(data:any){
    this.searchValue = data;
    this.req_parameter.search_param = this.searchValue;
    this.getUserList();
  }

  updateSort(sort:Sort){
    if (sort.direction) {
      this.req_parameter.sort_order = sort.direction;
      this.req_parameter.sort_by = sort.active;
    }else{
      this.req_parameter.sort_order = "";
      this.req_parameter.sort_by = "";
    }
    this.getUserList();
  }

}
